import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { firstValueFrom, take } from "rxjs";
import { RoleHelper } from "./static-classes/role-helper";
import { UserService } from "./user.service";

export const canActivateConfigureRoute: CanActivateFn = async () => {
    const router = inject(Router);
    const userService = inject(UserService);

    await firstValueFrom(userService.userStream.pipe(take(1)));

    if (userService.hasAnyRole([RoleHelper.ROLE_EDITOR, RoleHelper.ROLE_TESTER, RoleHelper.ROLE_ADMIN])) {
        return true;
    }

    return router.parseUrl('/error/access-denied');
};
